import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { EDITOR_COLORS, editorText } from '../../../styles/editorTheme';
import { useActiveAccountStore } from '../../../stores/activeAccountStore';
import { AccountFilterSelect } from '../AccountFilterSelect';

export const LogsView: React.FC = () => {
  const activeAccountId = useActiveAccountStore((state) => state.activeAccountId);
  // Draft filter value only — nothing loads until the log viewer exists and applies it.
  const [accountId, setAccountId] = useState<string | null>(null);

  return (
    <View style={styles.panel}>
      <View style={styles.filterRow}>
        <Text style={styles.filterLabel}>Account</Text>
        <AccountFilterSelect value={accountId ?? activeAccountId} onChange={(id) => setAccountId(id)} />
      </View>
      <View style={styles.placeholderCard}>
        <Text style={styles.placeholderTitle}>Logs</Text>
        <Text style={styles.placeholderText}>
          System activity and audit log viewer — coming soon.
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  panel: {
    padding: 20,
  },
  filterRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
  },
  filterLabel: {
    ...editorText,
    color: EDITOR_COLORS.textSecondary,
    marginRight: 8,
  },
  placeholderCard: {
    backgroundColor: EDITOR_COLORS.background,
    borderRadius: 12,
    padding: 20,
  },
  placeholderTitle: {
    ...editorText,
    color: EDITOR_COLORS.textPrimary,
    marginBottom: 8,
  },
  placeholderText: {
    ...editorText,
    color: EDITOR_COLORS.textMuted,
    lineHeight: 20,
  },
});
